import React, { Fragment } from "react";

const ArticleSection = ({ header, blocks, component }) => (
  <Fragment>
    {header && <div className="f4 fw5 pt4">{header}</div>}
    {(component && component()) ||
      (blocks &&
        blocks.map((block, blockIx) => (
          <div key={blockIx} className="f5 pt2 lh-copy">
            {block}
          </div>
        )))}
  </Fragment>
);

const TermBlocks = ({ config }) =>
  config.map(({ header, blocks, component }, configIx) => (
    <article className="pt3" key={configIx}>
      {header && <div className="f3 f2-l fw5 pt3">{header}</div>}
      {(component && component()) ||
        (blocks &&
          blocks.map((block, blockIx) => (
            <ArticleSection {...block} key={blockIx} />
          )))}
    </article>
  ));

export default TermBlocks;
